// Generated by CoffeeScript 2.7.0
var RatingMixin;

export default RatingMixin = {
  methods: {
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      return this.value = entry.value;
    }
  }
};
